import { axios } from "../lib/axios";

export const getService = async function (serviceId) {
  try {
    const response = await axios.get("settings/getservice", {
      params: { serviceId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getServices = async function () {
  try {
    const response = await axios.get("booking/getservices");
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const addService = async function (model) {
  try {
    const response = await axios.post("booking/addservice", model, {
      headers: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateService = async function (model) {
  try {
    const response = await axios.post("booking/updateservice", model, {
      header: { "Content-Type": "multipart/form-data" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};
